<template>
  <div class="msg_dialog" @click.stop="closeBtn()">
    <div class="msg_dialog_content">
      <p v-if="isSuc"><i class="iconfont icon-succ mr20"></i> <span>{{txt}}</span></p>
      <p v-if="!isSuc"><i class="el-icon-error mr20"></i> <span>{{txt}}</span></p>
    </div>
  </div>
</template>

<script type="es6">
  export default {
    name: 'msg-dialog',
    props: ['txt', 'isSuc', 'contentType'],
    methods: {
      closeBtn() {
        this.$emit('closebtn', false);
      }
    },
    created() {
      // console.log('类型具体内容', this.contentType);
      if (this.contentType != 'sllSynchronizationOfInventory' || this.contentType != 'sglSynchronizationOfInventory') {
        // console.log(999);
        let time = 3;
        const self = this;
        const timer = setInterval(function () {
          console.log(time);
          time = --time;
          if (time < 1) {
            self.closeBtn();
            clearInterval(timer);
          }
        }, 1000);
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../assets/css/base-color";

  .msg_dialog {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 999;
    /*background-color: rgba(255, 255, 0, .2);*/
    display: flex;
    justify-content: center;
    align-items: center;

    .msg_dialog_content {
     /* width: 380px;
      min-width: 380px; */
      min-width: 190px;
      padding: 45px 35px;
      box-shadow: 0 0 8px rgba(0,0,0,.6);
      background-color: #ffffff;

      p {
        .el-icon-error, .icon-succ {
          color: $cred;
          font-size: 30px;
          float: left;
        }

        .icon-succ {
          color: #2d6dcc;
        }

        span {
          display: inline-block;
          height: 30px;
          line-height: 30px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/public-component/msg-dialog.vue